function btyOnVariantChange({ target: element }) {
	// Ignorar eventos que no procedan del selector de variantes.
	if (!element || !element.closest('.product-variants')) {
		return;
	}

	const isRadio = element.type === 'radio';
	const isSelect = element.tagName && element.tagName.toLowerCase() === 'select';

	// Procesar únicamente radios y selectores de variantes.
	if (!isRadio && !isSelect) {
		return;
	}

	const mainElement = this.querySelector('main');
	const productElement = this.querySelector('.main-product');
	const recentElement = this.querySelector('.product-recently-viewed');

	if (!mainElement || !productElement) {
		return;
	}

	const oldProductUrl = productElement.dataset.productUrl;

	let newProductUrl = '';
	let newVariantId = '';
	let allProductUrl = [];
	let firstSelectedProductUrl = '';

	const firstProductVariants = productElement.querySelector(
		'.product-variants:first-child'
	);

	// Cambio mediante botón radio.
	if (isRadio) {
		newProductUrl = element.dataset.productUrl || '';
		newVariantId = element.dataset.variantId || '';

		allProductUrl = Array.from(
			this.querySelectorAll('.variant-field input')
		)
			.map((input) => input.dataset.productUrl)
			.filter((url) => url && url.trim() !== '')
			.filter((url, index, self) => self.indexOf(url) === index);

		if (firstProductVariants) {
			const firstCheckedInput = firstProductVariants.querySelector(
				'.variant-field:first-child input:checked'
			);

			if (firstCheckedInput) {
				firstSelectedProductUrl =
					firstCheckedInput.dataset.productUrl || '';
			}
		}
	}

	// Cambio mediante selector desplegable.
	if (isSelect) {
		const selectedOption = element.selectedOptions
			? element.selectedOptions[0]
			: null;

		if (!selectedOption) {
			return;
		}

		newProductUrl = selectedOption.dataset.productUrl || '';
		newVariantId = selectedOption.dataset.variantId || '';

		allProductUrl = Array.from(
			this.querySelectorAll('.variant-field select option')
		)
			.map((option) => option.dataset.productUrl)
			.filter((url) => url && url.trim() !== '')
			.filter((url, index, self) => self.indexOf(url) === index);

		if (firstProductVariants) {
			const firstCheckedOption = firstProductVariants.querySelector(
				'.variant-field:first-child select option:checked'
			);

			if (firstCheckedOption) {
				firstSelectedProductUrl =
					firstCheckedOption.dataset.productUrl || '';
			}
		}
	}

	// No realizar ninguna petición si no existe una URL válida.
	if (!newProductUrl) {
		return;
	}

	let params = '';

	if (newVariantId) {
		params = `variant=${encodeURIComponent(newVariantId)}`;
	}

	const buildUrl = (url) => {
		if (!url) {
			return '';
		}

		return params ? `${url}?${params}` : url;
	};

	const reinitializeProduct = () => {
		if (typeof btyAnimationImageLoad === 'function') {
			btyAnimationImageLoad();
		}

		if (typeof btyPhotoswipeHandle === 'function') {
			btyPhotoswipeHandle();
		}

		if (typeof btyProductVariants === 'function') {
			btyProductVariants();
		}

		if (typeof btyProductPerformed === 'function') {
			btyProductPerformed();
		}

		if (typeof btyQuantityButton === 'function') {
			btyQuantityButton();
		}

		if (typeof btyAddToCart === 'function') {
			btyAddToCart();
		}

		if (typeof btyProductPopup === 'function') {
			btyProductPopup();
		}

		if (typeof btyProductGallery === 'function') {
			btyProductGallery();
		}

		if (
			recentElement &&
			typeof btyRecentlyProduct === 'function'
		) {
			btyRecentlyProduct();
		}
	};

	const updateProductHtml = (responseText, productUrl) => {
		if (typeof btyGetSectionHtml !== 'function') {
			return;
		}

		const newMainHtml = btyGetSectionHtml(responseText, 'main');

		if (!newMainHtml) {
			return;
		}

		mainElement.innerHTML = newMainHtml;

		if (newVariantId) {
			window.history.replaceState(
				{},
				'',
				`${productUrl}?variant=${encodeURIComponent(newVariantId)}`
			);
		} else {
			window.history.replaceState({}, '', productUrl);
		}
	};

	const fetchProduct = (productUrl) => {
		const requestUrl = buildUrl(productUrl);

		if (!requestUrl) {
			return Promise.reject(
				new Error('No se ha encontrado una URL de producto válida.')
			);
		}

		return fetch(requestUrl)
			.then((response) => {
				if (!response.ok) {
					throw new Error(
						`Error al cargar el producto. Código HTTP: ${response.status}`
					);
				}

				return response.text();
			})
			.then((responseText) => {
				updateProductHtml(responseText, productUrl);
			});
	};

	fetch(buildUrl(newProductUrl))
		.then((response) => {
			if (!response.ok) {
				throw new Error(
					`Error al cargar el producto. Código HTTP: ${response.status}`
				);
			}

			return response.text();
		})
		.then((responseText) => {
			if (
				newProductUrl &&
				oldProductUrl !== newProductUrl
			) {
				updateProductHtml(responseText, newProductUrl);
				return;
			}

			if (
				oldProductUrl &&
				!allProductUrl.includes(oldProductUrl) &&
				firstSelectedProductUrl
			) {
				return fetchProduct(firstSelectedProductUrl);
			}
		})
		.catch((error) => {
			console.error(
				'Error al actualizar la variante del producto:',
				error
			);
		})
		.finally(() => {
			reinitializeProduct();
		});
}

function btyCombinedProduct(doc = document) {
	const selectors = doc.querySelectorAll('.template-product');

	if (!selectors.length) {
		return;
	}

	selectors.forEach((element) => {
		// Evita registrar varias veces el mismo listener.
		element.removeEventListener('change', btyOnVariantChange);
		element.addEventListener('change', btyOnVariantChange);
	});
}

document.addEventListener('DOMContentLoaded', function () {
	if (
		window.ProductModel &&
		typeof window.ProductModel.loadShopifyXR === 'function'
	) {
		window.ProductModel.loadShopifyXR();
	}

	btyCombinedProduct();
});

document.addEventListener('shopify:section:load', function (event) {
	const section = event.target.closest('section.shopify-section');

	if (!section) {
		return;
	}

	btyCombinedProduct(section);
});

document.addEventListener('shopify:section:select', function (event) {
	const section = event.target;

	if (!section) {
		return;
	}

	btyCombinedProduct(section);
});

document.addEventListener('shopify:block:select', function (event) {
	const section = event.target.closest('.shopify-section');

	if (!section) {
		return;
	}

	btyCombinedProduct(section);
});